var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_21888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8375 47.4374H39.5475C37.22 47.4374 35.3125 45.4774 35.3125 43.0624C35.3125 42.3449 35.9075 41.7499 36.625 41.7499C37.3425 41.7499 37.9375 42.3449 37.9375 43.0624C37.9375 44.0249 38.655 44.8124 39.5475 44.8124H42.8375C43.52 44.8124 44.0625 44.1999 44.0625 43.4474C44.0625 42.5024 43.8 42.3624 43.205 42.1524L37.9375 40.3149C36.8175 39.9299 35.3125 39.1074 35.3125 36.5349C35.3125 34.3474 37.045 32.5449 39.1625 32.5449H42.4525C44.78 32.5449 46.6875 34.5049 46.6875 36.9199C46.6875 37.6374 46.0925 38.2324 45.375 38.2324C44.6575 38.2324 44.0625 37.6374 44.0625 36.9199C44.0625 35.9574 43.345 35.1699 42.4525 35.1699H39.1625C38.48 35.1699 37.9375 35.7824 37.9375 36.5349C37.9375 37.4799 38.2 37.6199 38.795 37.8299L44.0625 39.6674C45.1825 40.0524 46.6875 40.8749 46.6875 43.4474C46.6875 45.6524 44.955 47.4374 42.8375 47.4374Z",
    fill: "url(#paint0_linear_14_21888)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 49.1875C40.2825 49.1875 39.6875 48.5925 39.6875 47.875V32.125C39.6875 31.4075 40.2825 30.8125 41 30.8125C41.7175 30.8125 42.3125 31.4075 42.3125 32.125V47.875C42.3125 48.5925 41.7175 49.1875 41 49.1875Z",
    fill: "url(#paint1_linear_14_21888)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 58.8125C30.6225 58.8125 22.1875 50.3775 22.1875 40C22.1875 29.6225 30.6225 21.1875 41 21.1875C41.7175 21.1875 42.3125 21.7825 42.3125 22.5C42.3125 23.2175 41.7175 23.8125 41 23.8125C32.075 23.8125 24.8125 31.075 24.8125 40C24.8125 48.925 32.075 56.1875 41 56.1875C49.925 56.1875 57.1875 48.925 57.1875 40C57.1875 39.2825 57.7825 38.6875 58.5 38.6875C59.2175 38.6875 59.8125 39.2825 59.8125 40C59.8125 50.3775 51.3775 58.8125 41 58.8125Z",
    fill: "url(#paint2_linear_14_21888)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.75 32.5625H49.75C49.0325 32.5625 48.4375 31.9675 48.4375 31.25V24.25C48.4375 23.5325 49.0325 22.9375 49.75 22.9375C50.4675 22.9375 51.0625 23.5325 51.0625 24.25V29.9375H56.75C57.4675 29.9375 58.0625 30.5325 58.0625 31.25C58.0625 31.9675 57.4675 32.5625 56.75 32.5625Z",
    fill: "url(#paint3_linear_14_21888)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 32.5625C49.4175 32.5625 49.085 32.44 48.8225 32.1775C48.315 31.67 48.315 30.83 48.8225 30.3225L57.5725 21.5725C58.08 21.065 58.92 21.065 59.4275 21.5725C59.935 22.08 59.935 22.92 59.4275 23.4275L50.6775 32.1775C50.415 32.44 50.0825 32.5625 49.75 32.5625Z",
    fill: "url(#paint4_linear_14_21888)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_21888",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_21888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_21888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_21888",
    x1: 41,
    y1: 32.5449,
    x2: 41,
    y2: 47.4374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_21888",
    x1: 41,
    y1: 30.8125,
    x2: 41,
    y2: 49.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_21888",
    x1: 41,
    y1: 21.1875,
    x2: 41,
    y2: 58.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_21888",
    x1: 53.25,
    y1: 22.9375,
    x2: 53.25,
    y2: 32.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_21888",
    x1: 54.125,
    y1: 21.1919,
    x2: 54.125,
    y2: 32.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.1b920141913529c91b5e142f90d87dea.svg";
export { ForwardRef as ReactComponent };